import { render, staticRenderFns } from "./PersonalityWheel.vue?vue&type=template&id=63dc538b"
import script from "./PersonalityWheel.vue?vue&type=script&lang=js"
export * from "./PersonalityWheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports